/**
 * BC Sugestões — "Quem leva este modelo também leva" (produto) e "Complete seu pedido" (gaveta e /cart).
 *
 * Marcação: snippets/bc-sugestoes.liquid imprime <bc-sugestoes data-modo="produto|sacola" ...>.
 * O elemento só busca dados quando chega perto da tela (IntersectionObserver), depois do conteúdo principal.
 * O botão "Escolher tamanhos" usa data-bc-rapida-abrir="HANDLE": o assets/bc-atacado.js abre a mesma
 * janela de compra rápida dos cards de coleção (delegação de clique no document). Nada aqui mexe no carrinho.
 *
 * Fontes, nesta ordem (sem repetir estampa, sem o próprio produto, sem kit/oversized/esgotado):
 *   1. co-compra real dos pedidos pagos (assets/bc-cocompra.json, gerado fora do tema);
 *   2. API nativa /recommendations/products.json?intent=related;
 *   3. mais vendidos da coleção do gênero (sections/bc-sugestoes-dados.liquid pela Section Rendering API,
 *      porque o /collections/X/products.json ignora sort_by).
 * JS puro, sem jQuery.
 */
(function () {
  'use strict';

  if (window.BCSugestoes) return;

  var CFG = window.BCAtacadoConfig || {};
  var RAIZ = (CFG.urlRaiz || '/').replace(/\/$/, '');
  var PRECO_BASE = CFG.precoBase || 3990;
  var FAIXAS = (CFG.faixas || [{ qtd: 10, preco: 3490 }, { qtd: 20, preco: 3190 }]).slice().sort(function (a, b) { return a.qtd - b.qtd; });
  var MENOR = FAIXAS.length ? FAIXAS[FAIXAS.length - 1].preco : PRECO_BASE;

  /* ---------- utilidades ---------- */

  function dinheiro(c) {
    if (window.BCAtacado && window.BCAtacado.dinheiro) return window.BCAtacado.dinheiro(c);
    var p = (Math.abs(c) / 100).toFixed(2).split('.');
    return (c < 0 ? '-' : '') + 'R$ ' + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + p[1];
  }

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  function json(url) {
    return fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }

  // cache curto na sessão: a gaveta é re-renderizada a cada mudança e não pode piscar nem refazer as buscas
  var memoria = {};
  function cacheado(chave, minutos, buscar) {
    if (memoria[chave]) return memoria[chave];
    try {
      var bruto = sessionStorage.getItem('bcsug:' + chave);
      if (bruto) {
        var salvo = JSON.parse(bruto);
        if (salvo && salvo.ate > Date.now()) { memoria[chave] = Promise.resolve(salvo.v); return memoria[chave]; }
      }
    } catch (e) { /* sem sessionStorage: segue sem cache */ }
    memoria[chave] = buscar().then(function (v) {
      try { sessionStorage.setItem('bcsug:' + chave, JSON.stringify({ ate: Date.now() + minutos * 60000, v: v })); } catch (e) { /* cheio ou bloqueado */ }
      return v;
    }, function (erro) { delete memoria[chave]; throw erro; });
    return memoria[chave];
  }

  /* ---------- estampa (handle-base) ---------- */

  // cores que aparecem no handle logo depois do gênero: camiseta-feminina-verde-menta-tua-graca-me-basta
  var CORES = ['verde-menta', 'verde-militar', 'verde-agua', 'verde-bandeira', 'azul-marinho', 'azul-bebe', 'azul-royal', 'off-white',
    'branca', 'branco', 'baranca', 'preta', 'preto', 'vermelha', 'vermelho', 'azul', 'marrom', 'salmao', 'turquesa', 'cinza',
    'pink', 'rosa', 'menta', 'verde', 'bege', 'amarela', 'amarelo', 'lilas', 'mescla', 'chumbo', 'creme', 'vinho', 'laranja', 'roxa', 'roxo', 'nude', 'caramelo'];

  /** "camiseta-feminina-azul-deus-e-muito-maior" e "t-shirt-feminina-preta-...-894497158" viram "feminina-deus-e-muito-maior". */
  function base(handle) {
    var h = String(handle || '').toLowerCase().replace(/-\d{6,}$/, '').replace(/^copia-de-/, '');
    var m = h.match(/^(?:camiseta|camisa|t-shirt|tshirt|blusa)-(feminina|masculina|infantil|unissex)-(.+)$/);
    if (!m) return h;
    var resto = m[2];
    for (var i = 0; i < CORES.length; i++) {
      if (resto.indexOf(CORES[i] + '-') === 0) { resto = resto.slice(CORES[i].length + 1); break; }
    }
    return m[1] + '-' + resto;
  }

  function genero(handle) {
    var m = String(handle || '').match(/-(feminina|masculina|infantil)-/);
    return m ? m[1] : '';
  }

  /* ---------- produto elegível ---------- */

  /** Mesmo critério do botão "Escolher tamanhos" dos cards (snippets/bc-card-tamanhos.liquid). */
  function elegivel(p) {
    if (!p || !p.available || !p.handle) return false;
    if (/(^|-)(kit|oversized?)(-|$)/.test(p.handle)) return false;
    var tags = (p.tags || []).join(' ').toLowerCase();
    if (/\bkit\b|oversized/.test(tags) || /oversized|\bkit\b/i.test(p.title || '') || /oversized|kit/i.test(p.type || '')) return false;
    if (!p.options || p.options.length !== 1) return false;
    if (p.variants && p.variants.length === 1 && /default/i.test(p.variants[0].title || '')) return false;
    return (p.price || 0) === PRECO_BASE;
  }

  /** Forma única usada pelos cards, venha de /products/X.js, /recommendations ou da seção de dados. */
  function enxuto(p) {
    return {
      id: p.id, handle: p.handle, title: p.title, available: p.available, price: p.price,
      options: p.options ? p.options.map(function (o) { return typeof o === 'string' ? o : o.name; }) : [],
      variants: p.variants ? p.variants.slice(0, 1).map(function (v) { return { title: v.title }; }) : null,
      tags: p.tags || [], type: p.type || '',
      img: p.featured_image && typeof p.featured_image === 'object' ? p.featured_image.src : (p.featured_image || p.img || '')
    };
  }

  /* ---------- fontes ---------- */

  var urlCocompra = '';

  /** { estampa: [[handle, contagem], ...] } com as chaves normalizadas pela mesma função base(). */
  function cocompra() {
    if (!urlCocompra) return Promise.resolve({});
    return cacheado('cocompra:' + urlCocompra, 360, function () {
      return json(urlCocompra).then(function (bruto) {
        var mapa = {};
        var dados = bruto && bruto.dados ? bruto.dados : bruto;
        Object.keys(dados || {}).forEach(function (k) {
          var lista = dados[k];
          if (!Array.isArray(lista)) return;
          var chave = base(k);
          var alvo = mapa[chave] || (mapa[chave] = []);
          lista.forEach(function (it) {
            // aceita ["handle", 12], { handle, count|contagem|n } ou só "handle"
            var h = Array.isArray(it) ? it[0] : (typeof it === 'string' ? it : (it.handle || it.h));
            var n = Array.isArray(it) ? it[1] : (typeof it === 'string' ? 1 : (it.count || it.contagem || it.n || 1));
            if (h) alvo.push([String(h), +n || 1]);
          });
        });
        return mapa;
      });
    }).catch(function () { return {}; });
  }

  function produto(handle) {
    return cacheado('p:' + handle, 30, function () {
      return json(RAIZ + '/products/' + encodeURIComponent(handle) + '.js').then(enxuto);
    }).catch(function () { return null; });
  }

  function relacionados(id) {
    if (!id) return Promise.resolve([]);
    return cacheado('rel:' + id, 30, function () {
      return json(RAIZ + '/recommendations/products.json?product_id=' + id + '&limit=10&intent=related')
        .then(function (r) { return (r.products || []).map(enxuto); });
    }).catch(function () { return []; });
  }

  function maisVendidos(colecao) {
    colecao = colecao || 'camisetas';
    return cacheado('mv:' + colecao, 30, function () {
      return fetch(RAIZ + '/collections/' + encodeURIComponent(colecao) + '?sort_by=best-selling&section_id=bc-sugestoes-dados', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('mv ' + r.status); return r.text(); })
        .then(function (html) {
          var m = html.match(/<script[^>]*data-bc-sug-dados[^>]*>([\s\S]*?)<\/script>/);
          return m ? JSON.parse(m[1]).filter(Boolean).map(enxuto) : [];
        });
    }).catch(function () { return []; });
  }

  /**
   * Junta as fontes na ordem de qualidade.
   * excluir: estampas de origem (o produto aberto, o que já está na sacola); excluirHandles: handles exatos que não aparecem.
   * Co-compra real: até 2 cores por estampa, contando a de origem (a coleção Brasil, por exemplo, vende em bloco
   * cruzando cores). Relacionados e mais vendidos: uma cor por estampa e nunca a estampa de origem (ali é só semelhança).
   */
  function montarLista(opcoes) {
    var quantos = opcoes.quantos;
    var porBase = {}, porHandle = {};
    (opcoes.excluir || []).forEach(function (b) { porBase[b] = 1; });
    (opcoes.excluirHandles || []).forEach(function (h) { porHandle[h] = true; });
    var saida = [];

    function aceitar(p, fonte) {
      if (saida.length >= quantos || !elegivel(p) || porHandle[p.handle]) return;
      var b = base(p.handle);
      var n = porBase[b] || 0;
      if (n >= (fonte === 'cocompra' ? 2 : 1)) return;
      porBase[b] = n + 1;
      porHandle[p.handle] = true;
      p.fonte = fonte;
      saida.push(p);
    }

    return cocompra().then(function (mapa) {
      // soma as contagens de todas as estampas de origem (na sacola podem ser várias)
      var pontos = {};
      (opcoes.origens || []).forEach(function (b) {
        (mapa[b] || []).forEach(function (par) { pontos[par[0]] = (pontos[par[0]] || 0) + par[1]; });
      });
      // busca o dobro do necessário (alguns podem estar esgotados agora)
      var escolhidos = Object.keys(pontos).sort(function (a, b) { return pontos[b] - pontos[a]; })
        .filter(function (h) { return !porHandle[h]; })
        .slice(0, quantos * 2);
      return Promise.all(escolhidos.map(produto)).then(function (lista) {
        lista.forEach(function (p) { aceitar(p, 'cocompra'); });
      });
    }).then(function () {
      if (saida.length >= quantos) return;
      return Promise.all((opcoes.idsRelacionados || []).slice(0, 3).map(relacionados)).then(function (listas) {
        // intercala as listas para a sacola não ficar só com parecidos do primeiro item
        for (var i = 0; i < 10; i++) listas.forEach(function (l) { if (l[i]) aceitar(l[i], 'relacionados'); });
      });
    }).then(function () {
      if (saida.length >= quantos) return;
      return maisVendidos(opcoes.colecao).then(function (lista) {
        lista.forEach(function (p) { aceitar(p, 'mais-vendidos'); });
        // coleção do gênero sem itens suficientes: completa com a geral
        if (saida.length < quantos && opcoes.colecao && opcoes.colecao !== opcoes.colecaoGeral) {
          return maisVendidos(opcoes.colecaoGeral).then(function (l2) { l2.forEach(function (p) { aceitar(p, 'mais-vendidos'); }); });
        }
      });
    }).then(function () { return saida; });
  }

  /* ---------- cards ---------- */

  function imagem(url, largura) {
    if (!url) return '';
    var u = (url.indexOf('//') === 0 ? 'https:' + url : url).replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + largura;
  }

  /**
   * Preço igual ao dos cards de coleção (snippets/product-item.liquid, estilos .bc-card-preco/.bc-card-faixas do bc-atacado.css
   * e bc-legivel.css): "A partir de R$ 31,90 por peça" e, só no card largo, "Preço cai conforme a quantidade" embaixo.
   * No máximo 2 linhas (revisão leiga, rodada 1). Não usa "De ... a ..." para não parecer promoção.
   */
  var PRECO_HTML = '<p class="bc-sug__preco">' +
    '<span class="bc-card-preco"><span class="bc-card-preco__txt">A partir de</span> ' + dinheiro(MENOR).replace(' ', '&nbsp;') + ' <span class="bc-card-preco__txt">por peça</span></span>' +
    '<span class="bc-card-faixas"><span class="bc-card-faixas__curto">Preço cai conforme a quantidade</span></span>' +
    '</p>';

  function tituloCurto(t) {
    return String(t || '').replace(/^(camiseta|t-shirt|camisa)\s+/i, '');
  }

  function card(p, tamanhoImg) {
    var url = RAIZ + '/products/' + p.handle;
    var src = p.img ? imagem(p.img, 360) : '';
    var srcset = p.img ? [180, 270, 360, 540].map(function (w) { return esc(imagem(p.img, w)) + ' ' + w + 'w'; }).join(', ') : '';
    return '<li class="bc-sug__item" data-fonte="' + esc(p.fonte) + '">' +
      '<a class="bc-sug__foto" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' +
      (src ? '<img src="' + esc(src) + '" srcset="' + srcset + '" sizes="' + tamanhoImg + '" alt="" loading="eager" fetchpriority="low" decoding="async" width="360" height="360">' : '') +
      '</a>' +
      '<a class="bc-sug__titulo" href="' + esc(url) + '">' + esc(tituloCurto(p.title)) + '</a>' +
      PRECO_HTML +
      '<button type="button" class="bc-sug__btn" data-bc-rapida-abrir="' + esc(p.handle) + '" aria-label="Escolher tamanhos: ' + esc(p.title) + '"><span>Escolher<span class="bc-sug__btn-mais"> tamanhos</span></span></button>' +
      '</li>';
  }

  /* ---------- sacola ---------- */

  function lerCarrinho() {
    return fetch(RAIZ + '/cart.js', { cache: 'no-store', credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }

  // A frase de faixa/mínimo saiu daqui (revisão leiga, rodada 1: uma informação, um lugar). Quem diz quantas peças
  // faltam é a barra da gaveta e do /cart; o subtítulo da faixa é fixo, no snippets/bc-sugestoes.liquid.

  function colecaoDoGenero(el, generos) {
    var mapa = {};
    try { mapa = JSON.parse(el.getAttribute('data-colecoes') || '{}'); } catch (e) { mapa = {}; }
    var cont = {};
    generos.forEach(function (g) { if (g) cont[g] = (cont[g] || 0) + 1; });
    var top = Object.keys(cont).sort(function (a, b) { return cont[b] - cont[a]; })[0];
    return (top && mapa[top]) || mapa.geral || 'camisetas';
  }

  /* ---------- elemento ---------- */

  var observador = 'IntersectionObserver' in window ? new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (e.isIntersecting || e.intersectionRatio > 0) { observador.unobserve(e.target); e.target.carregar(); }
    });
  }, { rootMargin: '400px 0px' }) : null;

  class BCSugestoesEl extends HTMLElement {
    connectedCallback() {
      if (this._ligado) return;
      this._ligado = true;
      if (this.getAttribute('data-cocompra')) urlCocompra = this.getAttribute('data-cocompra');
      // já carregou nesta página com a mesma sacola (gaveta re-renderizada): pinta na hora, sem esperar a rolagem
      var chave = this._chaveSacola();
      if (chave && BCSugestoesEl.ultimo[chave]) { this._pintar(BCSugestoesEl.ultimo[chave]); return; }
      var self = this;
      // Sacola (gaveta e /cart): carrega já, em momento ocioso, sem esperar a rolagem. Na gaveta a faixa fica abaixo da
      // dobra dentro da área rolável dela, e o IntersectionObserver recorta por esse contêiner (o rootMargin só vale
      // para a janela): ele só dispararia quando o lojista rolasse até a faixa, que ficava só com os esqueletos.
      if (this.getAttribute('data-modo') === 'sacola' || !observador) {
        var agora = function () { if (self.isConnected && !self._feito && !self._carregando) self.carregar(); };
        if (window.requestIdleCallback) requestIdleCallback(agora, { timeout: 1200 }); else setTimeout(agora, 300);
        return;
      }
      observador.observe(this);
      // garantia na página de produto: carrega mesmo se o observador não disparar (aba em segundo plano, webview)
      var depois = function () { setTimeout(function () { if (self.isConnected && !self._feito) self.carregar(); }, 3000); };
      if (document.readyState === 'complete') depois(); else window.addEventListener('load', depois, { once: true });
    }

    disconnectedCallback() {
      if (observador) observador.unobserve(this);
      this._ligado = false;
    }

    _chaveSacola() {
      return this.getAttribute('data-modo') === 'sacola' ? 'sacola:' + (this.getAttribute('data-assinatura') || '') : '';
    }

    carregar() {
      var self = this;
      if (this._carregando) return;
      this._carregando = true;
      var pronto = this.getAttribute('data-modo') === 'sacola' ? this._dadosSacola() : this._dadosProduto();
      pronto.then(function (dados) {
        var chave = self._chaveSacola();
        if (chave) BCSugestoesEl.ultimo[chave] = dados;
        self._pintar(dados);
      }).catch(function () { self.hidden = true; })
        .then(function () { self._carregando = false; self._feito = true; });
    }

    _dadosProduto() {
      var handle = this.getAttribute('data-handle');
      var quantos = parseInt(this.getAttribute('data-quantos'), 10) || 8;
      return montarLista({
        quantos: quantos,
        origens: [base(handle)],
        excluir: [base(handle)],
        excluirHandles: [handle],
        idsRelacionados: [this.getAttribute('data-produto-id')],
        colecao: this.getAttribute('data-colecao'),
        colecaoGeral: this.getAttribute('data-colecao-geral') || 'camisetas'
      }).then(function (lista) { return { lista: lista, frase: '' }; });
    }

    _dadosSacola() {
      var self = this;
      var quantos = parseInt(this.getAttribute('data-quantos'), 10) || 4;
      return lerCarrinho().then(function (carrinho) {
        if (!carrinho.item_count) return { lista: [], frase: '' };
        // origens em ordem de quantidade: a estampa com mais peças pesa primeiro
        var itens = carrinho.items.slice().sort(function (a, b) { return b.quantity - a.quantity; });
        var bases = [], ids = [], generos = [];
        itens.forEach(function (i) {
          var b = base(i.handle);
          if (bases.indexOf(b) === -1) bases.push(b);
          if (ids.indexOf(i.product_id) === -1) ids.push(i.product_id);
          generos.push(genero(i.handle));
        });
        return montarLista({
          quantos: quantos,
          origens: bases,
          excluir: bases,
          excluirHandles: itens.map(function (i) { return i.handle; }),
          idsRelacionados: ids,
          colecao: colecaoDoGenero(self, generos),
          colecaoGeral: 'camisetas'
        }).then(function (lista) { return { lista: lista, frase: '' }; });
      });
    }

    _pintar(dados) {
      var lista = this.querySelector('[data-bc-sug-lista]');
      if (!lista) return;
      if (!dados.lista.length) { this.hidden = true; return; }
      var tam = this.getAttribute('data-modo') === 'sacola' ? '(max-width: 740px) 70vw, 200px' : '(max-width: 740px) 42vw, (max-width: 1000px) 33vw, 320px';
      // imagens sem lazy: o bloco só pinta quando já está perto da tela (produto) ou com poucos cards (sacola);
      // com lazy a 2ª linha do desktop e os cards fora do carrossel ficavam cinza por um tempo
      lista.innerHTML = dados.lista.map(function (p) { return card(p, tam); }).join('');
      this._pontos(lista);
      lista.classList.remove('bc-sug__lista--espera');
      this.hidden = false;
      this.setAttribute('data-pronto', '');
    }

    /** Pontos de rolagem do carrossel: um por card, o atual em destaque. Só aparecem quando há o que rolar. */
    _pontos(lista) {
      var self = this;
      var caixa = this.querySelector('.bc-sug__pontos');
      if (!caixa) {
        caixa = document.createElement('div');
        caixa.className = 'bc-sug__pontos';
        caixa.setAttribute('aria-hidden', 'true');
        lista.parentNode.insertBefore(caixa, lista.nextSibling);
      }
      var itens = lista.children;
      caixa.innerHTML = Array.prototype.map.call(itens, function () { return '<span class="bc-sug__ponto"></span>'; }).join('');
      var pontos = caixa.children;
      function marcar() {
        var rola = lista.scrollWidth > lista.clientWidth + 4;
        caixa.hidden = !rola;
        if (!rola || !itens.length) return;
        var passo = itens.length > 1 ? itens[1].offsetLeft - itens[0].offsetLeft : lista.clientWidth;
        var fim = lista.scrollLeft + lista.clientWidth >= lista.scrollWidth - 4;
        var atual = fim ? itens.length - 1 : Math.round(lista.scrollLeft / (passo || 1));
        Array.prototype.forEach.call(pontos, function (p, i) { p.classList.toggle('bc-sug__ponto--ativo', i === atual); });
      }
      if (!this._rolagemLigada) {
        this._rolagemLigada = true;
        lista.addEventListener('scroll', function () {
          if (self._pontoT) return;
          self._pontoT = (window.requestAnimationFrame || setTimeout)(function () { self._pontoT = 0; self._marcarPontos(); });
        }, { passive: true });
        // a gaveta fechada pode ter largura zero: o ResizeObserver acerta os pontos quando ela abre
        if (window.ResizeObserver) new ResizeObserver(function () { self._marcarPontos && self._marcarPontos(); }).observe(lista);
        else window.addEventListener('resize', function () { self._marcarPontos && self._marcarPontos(); }, { passive: true });
      }
      this._marcarPontos = marcar;
      marcar();
      // a largura final só existe depois do layout (gaveta abrindo, fontes): confere de novo
      setTimeout(marcar, 400);
    }
  }
  BCSugestoesEl.ultimo = {};

  if (window.customElements && !window.customElements.get('bc-sugestoes')) {
    window.customElements.define('bc-sugestoes', BCSugestoesEl);
  }

  // na página /cart o bloco não é re-renderizado pelo tema: refaz a conta quando a sacola muda
  function aoMudarCarrinho() {
    clearTimeout(aoMudarCarrinho._t);
    aoMudarCarrinho._t = setTimeout(function () {
      Array.prototype.forEach.call(document.querySelectorAll('bc-sugestoes[data-modo="sacola"][data-pronto]'), function (el) {
        el.removeAttribute('data-assinatura');
        el.carregar();
      });
    }, 400);
  }
  document.documentElement.addEventListener('cart:updated', aoMudarCarrinho);

  // usarCocompra: só para teste/diagnóstico (aponta a lista curada sem precisar de um elemento na página)
  window.BCSugestoes = { base: base, elegivel: elegivel, montarLista: montarLista, usarCocompra: function (u) { urlCocompra = u; } };
})();
